import React from 'react';
import { Link } from 'react-router-dom';
import type { Lesson } from '../types';
import './DayCard.css';

interface DayCardProps {
  lesson: Lesson;
  isCompleted: boolean;
  isLocked: boolean;
  isCurrent: boolean;
}

export const DayCard: React.FC<DayCardProps> = ({
  lesson,
  isCompleted,
  isLocked,
  isCurrent,
}) => {
  const cardClass = `day-card ${isCompleted ? 'completed' : ''} ${isLocked ? 'locked' : ''} ${isCurrent ? 'current' : ''}`;

  const content = (
    <>
      <div className="day-card-header">
        <span className="day-card-number">Ziua {lesson.id}</span>
        {isCompleted && <span className="day-card-check">✓</span>}
        {isLocked && <span className="day-card-lock">🔒</span>}
        {isCurrent && !isCompleted && <span className="day-card-badge">Curent</span>}
      </div>
      <h3 className="day-card-title">{lesson.titlu.replace(`Ziua ${lesson.id}: `, '')}</h3>
      <div className="day-card-meta">
        <span>Săptămâna {lesson.saptamana}</span>
        <span>•</span>
        <span>30 min</span>
      </div>
    </>
  );

  if (isLocked) {
    return (
      <div className={cardClass} aria-disabled="true">
        {content}
      </div>
    );
  }

  return (
    <Link to={`/lectie/${lesson.id}`} className={cardClass}>
      {content}
    </Link>
  );
};
